var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentsAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.598,
    height: 39.54,
    viewBox: "0 0 34.598 39.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f7072;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.471,34.6H6.943v2.471A2.472,2.472,0,0,0,9.414,39.54H34.127A2.472,2.472,0,0,0,36.6,37.069V7.414a2.472,2.472,0,0,0-2.471-2.471H31.655V2.471A2.472,2.472,0,0,0,29.184,0H4.471A2.472,2.472,0,0,0,2,2.471V32.127A2.472,2.472,0,0,0,4.471,34.6Zm24.713-2.471H4.471V2.471H29.184ZM34.127,7.414V37.069H9.414V34.6h19.77a2.472,2.472,0,0,0,2.471-2.471V7.414ZM11.885,8.649a1.236,1.236,0,0,0,1.236,1.236H25.477a1.236,1.236,0,0,0,0-2.471H13.121A1.236,1.236,0,0,0,11.885,8.649ZM8.178,17.3h17.3a1.236,1.236,0,0,0,0-2.471H8.178a1.236,1.236,0,1,0,0,2.471Zm0,4.943h17.3a1.236,1.236,0,0,0,0-2.471H8.178a1.236,1.236,0,0,0,0,2.471Zm0,4.943h17.3a1.236,1.236,0,0,0,0-2.471H8.178a1.236,1.236,0,0,0,0,2.471Z",
    transform: "translate(-2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentsAlt);
export default __webpack_public_path__ + "static/media/icon_documents_alt.e189a63c.svg";
export { ForwardRef as ReactComponent };